import Template from '../../component/Template.js';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';



export default function CourseAdd() {

  const [discipline, setDisciplineData] = useState([]);
  const [faculty, setFacultyData] = useState([]);
  const [semester, setSemester] = useState([]);
  const [coursecomponent, setCourseComponentData] = useState([]);
  const [coursecomponentstypes, setCoursecomponenttypeData] = useState([]);
  const [courselevel, setCourselevelData] = useState([]);
  const [courselevel1, setCourselevelData1] = useState([]);
  const [learningdomain, setLearningdomainData] = useState([]);
  const [programmeoutcome, setProgrammeoutcomeData] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [facultyname, setFacultyname] = useState(false);
  const [showLecture, setShowLecture] = useState(false);
  const [showTutorial, setShowTutorial] = useState(false);
  const [showPracticumLab, setShowPracticumLab] = useState(false);
  const [selectedCourseComponents, setSelectedCourseComponents] = useState([]);
  const [selectedCourseComponentsIDs, setSelectedCourseComponentsIDs] = useState([]);
  const [componentWiseData, setComponentWiseData] = useState({});
  const [semestechange, setsemestechange] = useState(false);

  const [coursecode, setCoursecode] = useState(false);
  const [coursecodedigit, setCoursecodedigit] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [flag, setFlag] = useState(false);
  const [schemeId, setSchemeId] = useState(null);

  const { http } = Api();

  const [lectureCredit, setLectureCredit] = useState(0);
  const [tutorialCredit, setTutorialCredit] = useState(0);
  const [practicalCredit, setPracticalCredit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);

  const [errors, setErrors] = useState({ cname: '', cfaculty: '', cdiscipline: '', ccurriculum: '', cinternal: '', cexternal: '', clevel: '', csemester: '', ccoursecode: '' });


  const [aecflag, setAecflag] = useState(false);
  const [minorflag, setMinorflag] = useState(false);
  const [minordata, setMinorData] = useState([]);

  const [ugpspecialisation, setugpspecialisation] = useState([]);
  const [ugpspecialisationflag, setugpspecialisationflag] = useState(false);

  const [courseType, setCourseType] = useState(false);

  const [theoryInternalEnabled, setTheoryInternalEnabled] = useState(false);
  const [theoryExternalEnabled, setTheoryExternalEnabled] = useState(false);

  const [practicalInternalEnabled, setPracticalInternalEnabled] = useState(false);
  const [practicalExternalEnabled, setPracticalExternalEnabled] = useState(false);

  const [lectureCredit1, setLectureCredit1] = useState(0);
  const [practicalCredit1, setPracticalCredit1] = useState(0);
  const [message, setMessage] = useState(false);
  const [commonError, setCommonError] = useState("");
  const [practicalCategoryType, setPracticalCategoryType] = useState('');

  const handleLectureCreditChange = (event) => {
    const value = parseFloat(event.target.value);
    setLectureCredit(value);
  };


  const handleTutorialCreditChange = (event) => {
    const value = parseFloat(event.target.value);
    setTutorialCredit(value);
  };


  const handlePracticalCreditChange = (event) => {
    const value = parseFloat(event.target.value);
    setPracticalCredit(value);
  };


  // useEffect(() => {

  //   const total = (isNaN(lectureCredit) ? 0 : lectureCredit) +
  //     (isNaN(tutorialCredit) ? 0 : tutorialCredit) +
  //     (isNaN(practicalCredit) ? 0 : practicalCredit);


  //     setTotalCredit(total);

  //   // if (total < 0 || total > 8) {
  //   //   setTotalCredit(0);
  //   //   toast.error('Total credit should be between 0 and 8');
  //   // }
  //   // else {
  //     setNumSections(total);
  //     const initialTotal = total === 0 ? 1 : total;
  //     setSectionsData(Array.from({ length: initialTotal }, (_, index) => index + 1).map(() => ({ outcome: '', domains: [] })));

  //   // }

  // }, [lectureCredit, tutorialCredit, practicalCredit]);


  useEffect(() => {


    const lecture = courseType === "P" ? 0 : lectureCredit1;
    const practical = courseType === "T" ? 0 : practicalCredit1;

    const total = Number(lecture) + Number(practical);


    if (total < 0 || total > 12) {
      setTotalCredit(0);
      toast.error('Total credit should be between 0 and 12');
    } else {
      setTotalCredit(total);
    }



  }, [practicalCredit1, lectureCredit1]);


  const navigate = useNavigate();

  useEffect(() => {

    if (sessionStorage.getItem("facultyname")) {
      setFacultyname(sessionStorage.getItem("facultyname"));

    }

    if (sessionStorage.getItem("semester_id")) {
      //setsemestechange(sessionStorage.getItem("semester_id"));
      setCourselevelData1(sessionStorage.getItem("courselevel"));
    }

    if (sessionStorage.getItem("scheme_id")) {
      setSchemeId(sessionStorage.getItem("scheme_id"));
    }
    const fetchData = async () => {
      try {


        const response1 = await http.get(`/Admin/getfaculty`);
        const response2 = await http.get(`/Admin/getdiscipline`, {
          params: {
            limit: '500'
          }
        });
        const response3 = await http.get(`/Admin/getcoursecomponent`);

        const response5 = await http.get(`/Admin/getcourselevel`);
        const response6 = await http.get(`/Admin/getlearningdomain`);
        const response7 = await http.get(`/Admin/getprogrammeoutcome`);
        const response8 = await http.get(`/Admin/getsemester`);


        setFacultyData(response1.data.data);
        setDisciplineData(response2.data.data);
        setCourseComponentData(response3.data);
        setCourselevelData(response5.data);

        setLearningdomainData(response6.data);
        setProgrammeoutcomeData(response7.data);
        setSemester(response8.data);

      } catch (error) {

        toast.error("somthing went wrong");
        console.error('Error fetching Course data:', error);

      }
    };

    fetchData();

  }, []);

  //04-03-2024-multiselect

  const learningoptions = learningdomain.map(learningdomains => ({
    value: learningdomains.id,
    label: learningdomains.learning_domain
  }));

  const outcomeoptions = programmeoutcome.map(programmeoutcomes => ({
    value: programmeoutcomes.id,
    label: programmeoutcomes.programme_outcome
  }));


  const [numSections, setNumSections] = useState(1); // Initialize with one section
  const [sectionsData, setSectionsData] = useState(Array.from({ length: 1 }, (_, index) => index + 1).map(() => ({ outcome: '', domains: [] }))); // Initialize with one section's data
  const handleCourseOutcomeChange = (event) => {
    let value = parseInt(event.target.value);
    value = Math.max(1, Math.min(value, 20));
    setNumSections(value);
    // Update sections data based on the new number of sections
    setSectionsData(Array.from({ length: value }, (_, index) => index + 1).map(() => ({ outcome: '', domains: [] })));
  };


  // Define state variables and change handlers for Course Outcome multi-selects
  const [selectedOutcomeOptions, setSelectedOutcomeOptions] = useState(Array.from({ length: numSections }, () => []));
  const handleOutcomeChange = (selectedOptions, sectionIndex) => {
    const updatedSelectedOutcomeOptions = [...selectedOutcomeOptions];
    updatedSelectedOutcomeOptions[sectionIndex] = selectedOptions;
    setSelectedOutcomeOptions(updatedSelectedOutcomeOptions);
  };


  // Define state variables and change handlers for Learning Domain multi-selects
  const [selectedDomainOptions, setSelectedDomainOptions] = useState(Array.from({ length: numSections }, () => []));
  const handleDomainChange = (selectedOptions, sectionIndex) => {
    const updatedSelectedDomainOptions = [...selectedDomainOptions];
    updatedSelectedDomainOptions[sectionIndex] = selectedOptions;
    setSelectedDomainOptions(updatedSelectedDomainOptions);
  };



  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/")
  }


  const handleCourseComponentChangeqq = (selectedOptions) => {

    const selectedValues = selectedOptions.map(option => option.value);
    setSelectedCourseComponents(selectedValues);



  };

  const handleCourseComponentChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map(option => option.value);
    setSelectedCourseComponentsIDs(selectedValues);

    setSelectedCourseComponents(selectedOptions || []);

    setComponentWiseData(prev => {
      const updated = { ...prev };

      // Add new components
      selectedOptions?.forEach(opt => {
        if (!updated[opt.value]) {
          updated[opt.value] = {
            componentName: opt.label,
            total_credit: '',
            total_hours: ''
          };
        }
      });

      // Remove unselected components
      Object.keys(updated).forEach(key => {
        if (!selectedOptions?.some(opt => opt.value === parseInt(key))) {
          delete updated[key];
        }
      });

      return updated;
    });
  };

{/* Credit and Hours Section */ }

  // Prepare component-wise credit & hours for saving
  const courseComponentDetails = Object.entries(componentWiseData).map(
    ([component_id, data]) => ({
      component_id: parseInt(component_id),
      total_credit: Number(data.total_credit),
      total_hours: Number(data.total_hours)
    })
  );
  const total_credit = courseComponentDetails.reduce(
    (sum, c) => sum + c.total_credit,
    0
  );

  const total_hours = courseComponentDetails.reduce(
    (sum, c) => sum + c.total_hours,
    0
  );
  {/* Credit and Hours Section  end*/ }

  const validateForm = () => {

    const updatedErrors = {};
    let hasError = false;


    const course_name = document.getElementById('course_code').value;
    const faculty_id = document.getElementById('faculty_id').value;
    const discipline_id = document.getElementById('discipline_id').value;
    const awarded_discipline_id = document.getElementById('awarded_discipline_id').value;
    const course_curriculum_structure_component_id = document.getElementById('coursecomponentstype').value;
    // const internal_ratio = document.getElementById('internal_ratio').value;
    // const external_ratio = document.getElementById('external_ratio').value;
    const course_level = document.getElementById('courselevel_id').value;
    const semesterid = document.getElementById('semester_id').value;

    const course_ty = document.getElementById('courseidoftype').value;


    let coursecodelen = document.getElementById('inlineFormCourseCode').value;
    let coursecodelen1 = coursecode + coursecodelen;

    // Specialisation validation only if visible
    const specDropdown = document.getElementById("ugpspecialisation_group");
    const specRow = document.getElementById("spec_row");

    const practRow = document.getElementById("pract_row");
    const practical_type = document.getElementById('practicalType');

    const isSpecVisible = specRow && specRow.offsetParent !== null;
    const isPractVisible = practRow && practRow.offsetParent !== null;



    if (errors.ccoursecode) {
      updatedErrors.ccoursecode = 'Enter a valid number';
      hasError = true;
    }

    if (course_ty === "0") {
      updatedErrors.ccoursetype = 'Select  a Course Type';
      hasError = true;
    }

    if (coursecodelen1.length !== 12) {
      updatedErrors.ccoursecode = 'Length must be 12';
      hasError = true;
    }

    if (!/^\d{3}$/.test(coursecodelen)) {
      updatedErrors.ccoursecode = 'Last 3 characters must be numbers';
      hasError = true;
    }

    if (!course_name) {
      updatedErrors.cname = 'Enter a course name';
      hasError = true;
    }

    if (faculty_id === "0") {
      updatedErrors.cfaculty = 'Select  a faculty';
      hasError = true;
    }

    if (discipline_id === "0") {

      updatedErrors.cdiscipline = 'Select a discipline';
      hasError = true;
    }

    if (awarded_discipline_id === "0") {

      updatedErrors.awarded_discipline = 'Select awarded discipline';
      hasError = true;
    }

    if (semesterid === "0") {

      updatedErrors.csemester = 'Select a semester';
      hasError = true;
    }
    if (isSpecVisible) {
      const specValue = specDropdown.value;

      if (specValue === "") {
        updatedErrors.specialisation = "Select a specialisation";
        hasError = true;
      }
    }
    if (isPractVisible) {
      const practicalTypeValue = practical_type.value;

      if (practicalTypeValue === "") {
        updatedErrors.practicalType = "Select a practical category";
        hasError = true;
      }
    }
    setCommonError("");

    if (
      (theoryInternalEnabled && (!document.getElementById('theoryMin').value || !document.getElementById('theoryMax').value)) ||
      (theoryExternalEnabled && (!document.getElementById('theoryExternalMin').value || !document.getElementById('theoryExternalMax').value)) ||
      (practicalInternalEnabled && (!document.getElementById('practicalInternalMin').value || !document.getElementById('practicalInternalMax').value)) ||
      (practicalExternalEnabled && (!document.getElementById('practicalExternalMin').value || !document.getElementById('practicalExternalMax').value))
    ) {
      toast.error("An error occured in Mark Details");
      document.getElementById("Mark_Details").scrollIntoView({ behavior: 'smooth', block: 'start' });
      setCommonError("Please fill all required fields in Mark Details section");
      //setCommonError("Please fill all required fields in Mark Details section or disable the corresponding options");
      return; // Stop form submission
    }


    if (course_curriculum_structure_component_id === "") {

      updatedErrors.ccurriculum = 'Select a course curriculum structure component';
      hasError = true;
    }
if (total_credit !== totalCredit) {
  toast.error("Total credit you entered does not match the calculated total credit");
  return;  
  
}
    // if (!internal_ratio) {
    //   updatedErrors.cinternal = 'enter internal ratio';
    //   hasError = true;
    // }

    // if (!external_ratio) {
    //   updatedErrors.cexternal = 'enter external ratio';
    //   hasError = true;
    // }

    if (course_level === "0") {
      updatedErrors.clevel = 'Select a course level';
      hasError = true;
    }

    {/* Credit and Hours Section */ }

    // Credit & Hours Validation
    if (Object.keys(componentWiseData).length === 0) {
      updatedErrors.courseComponent = "Select at least one course component";
      hasError = true;
    } else {
      updatedErrors.componentErrors = {};

      Object.entries(componentWiseData).forEach(([id, component]) => {
        updatedErrors.componentErrors[id] = {};
        if (!component.total_credit || Number(component.total_credit) <= 0) {
          updatedErrors.componentErrors[id].total_credit = `Enter valid credit`;
          hasError = true;
        }

        if (!component.total_hours || Number(component.total_hours) <= 0) {
          updatedErrors.componentErrors[id].total_hours = `Enter valid hours`;
          hasError = true;
        }
        if (Object.keys(updatedErrors.componentErrors[id]).length === 0) {
          delete updatedErrors.componentErrors[id];
        }
      });
      if (Object.keys(updatedErrors.componentErrors).length === 0) {
        delete updatedErrors.componentErrors;
      }
    }
    {/* Credit and Hours Section end */ }



    if (hasError) {
      setErrors(updatedErrors);
      return false;

    } else {
      setErrors({ cname: '', cfaculty: '', cdiscipline: '', ccurriculum: '', cinternal: '', cexternal: '', clevel: '' });
      return true;
    }
  };



  const cancelForm = () => {
    navigate("/admin/course");
  };

  


  const saveForm = () => {
    if (validateForm()) {
      const course_name = document.getElementById('course_code').value;
      const faculty_id = document.getElementById('faculty_id').value;
      const discipline_id = document.getElementById('discipline_id').value;
      const awarded_discipline_id = document.getElementById('awarded_discipline_id').value;
      // const credit_lecture = showLecture ? document.getElementById('lecture').value.trim() : 0;
      // const credit_tutorial = showTutorial ? document.getElementById('tutorial').value.trim() : 0;
      // const credit_practical = showPracticumLab ? document.getElementById('practical').value.trim() : 0;

      let coursecode1 = document.getElementById('inlineFormCourseCode').value;
      coursecode1 = coursecode + coursecode1;

      const course_curriculum_structure_component_id = document.getElementById('coursecomponentstype').value;
      const course_level = document.getElementById('courselevel_id').value;
      const semesterid = document.getElementById('semester_id').value;
      const number_of_outcome = document.getElementById('courseoutcome').value;
      const remarksValue = document.getElementById('remarks').value;


      const course_ty = document.getElementById('courseidoftype').value === "0" ? 0 : document.getElementById('courseidoftype').value;

      const practEl = document.getElementById('practicalType');
      const practical_type = practEl ? (practEl.value === "0" ? 0 : practEl.value) : "";

      const courseType_theory = course_ty === "T" || course_ty === "B" ? lectureCredit1 : 0;
      const courseType_practical = course_ty === "P" || course_ty === "B" ? practicalCredit1 : 0;
      const credit_total = totalCredit;

      const aec_group = aecflag ? document.getElementById('aec_group').value : 0;
      const min_group = minorflag ? document.getElementById('minor_group').value : 0;
      const ugpspecialisation_group = ugpspecialisationflag ? parseInt(document.getElementById('ugpspecialisation_group').value) : 0;

      const theoryInternalMin = theoryInternalEnabled ? document.getElementById('theoryMin').value : null;
      const theoryInternalMax = theoryInternalEnabled ? document.getElementById('theoryMax').value : null;
      const theoryExternalMin = theoryExternalEnabled ? document.getElementById('theoryExternalMin').value : null;
      const theoryExternalMax = theoryExternalEnabled ? document.getElementById('theoryExternalMax').value : null;

      const practicalInternalMin = practicalInternalEnabled ? document.getElementById('practicalInternalMin').value : null;
      const practicalInternalMax = practicalInternalEnabled ? document.getElementById('practicalInternalMax').value : null;
      const practicalExternalMin = practicalExternalEnabled ? document.getElementById('practicalExternalMin').value : null;
      const practicalExternalMax = practicalExternalEnabled ? document.getElementById('practicalExternalMax').value : null;

      const selectedCourseComponentsids = selectedCourseComponentsIDs.map(component => parseInt(component));
      const status = "active";

      //console.log(course_name, faculty_id, discipline_id, course_curriculum_structure_component_id, course_level, semesterid, number_of_outcome, remarksValue, coursecode1, course_ty, courseType_theory, courseType_practical, credit_total, aec_group, min_group, theoryInternalMin, theoryInternalMax, theoryExternalMin, theoryExternalMax, practicalInternalMin, practicalInternalMax, practicalExternalMin, practicalExternalMax, status, selectedCourseComponentsids);

      const outcomes = [];
      for (let i = 0; i < number_of_outcome; i++) {
        try {
          const outcomeDescription = document.getElementById(`outcome${i}`).value;
          const learningDomainId = selectedDomainOptions[i].map(option => option.value);
          const programOutcomeId = selectedOutcomeOptions[i].map(option => option.value);

          if (!outcomeDescription || !learningDomainId.length || !programOutcomeId.length) {
            toast.error("Please fill all course outcomes");
            break; // Exit the loop
          } else {
            outcomes.push({
              outcome_slno: i + 1,
              outcome_description: outcomeDescription,
              learning_domain_id: learningDomainId,
              program_outcome_id: programOutcomeId
            });
          }
        } catch (error) {
          console.error("Error processing outcome:", error);
          toast.error("Please fill all course outcomes");
          setMessage("Please fill all course outcomes");

        }
      }
      if (outcomes.length == number_of_outcome) {

        http.post(`/Admin/savecourse`, {

          course_name: course_name,
          faculty_id: faculty_id,
          discipline_id: discipline_id,
          awarded_discipline_id: awarded_discipline_id,

          // credit_lecture: credit_lecture,
          // credit_tutorial: credit_tutorial,
          // credit_practical: credit_practical,

          course_curriculum_structure_component_id: course_curriculum_structure_component_id,

          // internal_ratio: internal_ratio,
          // external_ratio: external_ratio,

          course_level: course_level,
          outcome_number: number_of_outcome,
          remarks: remarksValue,
          status: status,
          course_component_id: selectedCourseComponentsids,

          // NEW (component-wise saving)
          course_components: courseComponentDetails,

          // Optional totals
          total_credit: total_credit,
          total_hours: total_hours,

          outcomes: outcomes,
          semester_id: semesterid,

          // credit: total,

          course_code: coursecode1,
          coursetype: course_ty,
          practical_type: practical_type,
          credit_theory: courseType_theory,
          credit_practical: courseType_practical,

          credit: credit_total,

          aec_group: aec_group,
          minor_id: min_group,
          specialisation_id: ugpspecialisation_group,

          TI_MIN: theoryInternalMin,
          TI_MAX: theoryInternalMax,
          TE_MIN: theoryExternalMin,
          TE_MAX: theoryExternalMax,
          PI_MIN: practicalInternalMin,
          PI_MAX: practicalInternalMax,
          PE_MIN: practicalExternalMin,
          PE_MAX: practicalExternalMax,

          TI: theoryInternalEnabled ? 1 : 0,
          TE: theoryExternalEnabled ? 1 : 0,
          PI: practicalInternalEnabled ? 1 : 0,
          PE: practicalExternalEnabled ? 1 : 0


        })
          .then(response => {
            if (response.data.status_code === "MSG1") {


              sessionStorage.setItem("faculty_id", faculty_id);
              const selectedFacultyname = faculty.find(facultys => parseInt(facultys.id) === parseInt(faculty_id));
              sessionStorage.setItem("facultyname", selectedFacultyname.faculty_name);
              sessionStorage.setItem("discipline_id", discipline_id);
              sessionStorage.setItem("semester_id", semesterid);
              sessionStorage.setItem("courselevel", courselevel1);
              toast.success("New Course  Added Successfully");

              setTimeout(() => {
                window.location.reload();
              }, 5000); // 5000 milliseconds = 5 seconds


            }
          })
          .catch(error => {

            if (error.response && error.response.data.status_code === "ERR2") {
              toast.error(error.response.data.data.info);
            } else if (error.response && error.response.data.status_code === "ERR1") {

              // extract errors
              const errors = error.response.data.data?.errors;

              // show only course_code error if exists
              if (errors?.course_code) {
                toast.error(errors.course_code[0]);

                setTimeout(() => {
                  course_code();
                  toast.info("New Course Code generated");
                }, 1000);


                return; // stop here
              }

              toast.error(error.response.data.data.message);
            }
            // 🔥 ADD THIS BLOCK BEFORE YOUR 422 GENERAL BLOCK
            else if (error.response?.data?.data?.errors?.course_code) {
              toast.error(error.response.data.data.errors.course_code[0]);
              setTimeout(() => {
                course_code();
                toast.info("New Course Code generated");

              }, 1000);


            }
            else if (error.response.status === 422) {
              setMessage("Please fill mandatory fields");
              toast.error(error.response.data.errors);
            }
            else {
              toast.error("Something Went Wrong");
            }
          });


        // console.log(course_name, faculty_id, discipline_id, credit_lecture, credit_tutorial, credit_practical,
        //   course_curriculum_structure_component_id, internal_ratio, external_ratio, course_level, number_of_outcome,
        //   remarksValue, status, selectedCourseComponentsids, outcomes);
      }

    }

    else {
      toast.error("An error occured");
      document.getElementById("main_section").scrollIntoView({ behavior: 'smooth', block: 'start' });

    }
  };

  //used to get dicipline based on faculty
  const isdisiplin = () => {
    setsemestechange(false);
    setCoursecomponenttypeData([]);
    const faculty_id = document.getElementById('faculty_id').value;
    // const selectedFaculty = faculty.find(facultys => parseInt(facultys.id) === parseInt(faculty_id));
    setFacultyname(parseInt(faculty_id)); // Logic changed, but the variable names remain the same—because laziness won! 😆
  }



  const issemester = () => {
    const semester_id = parseInt(document.getElementById('semester_id').value, 10);
    setsemestechange(semester_id);
    switch (semester_id) {
      case 1:
      case 2:
        setCourselevelData1(1);
        break;
      case 3:
      case 4:
        setCourselevelData1(2);
        break;
      case 5:
      case 6:
        setCourselevelData1(3);
        break;
      case 7:
      case 8:
        setCourselevelData1(4);
        break;

    }


  }

  useEffect(() => {

    const fetchData = async () => {

      try {

        const response = await http.get('/Admin/getcourseComponentStructure', {
          params: {
            semester_id: semestechange,
            scheme_id: schemeId
          }
        })
        // http.get(`/Admin/getcourseComponentStructure/${semestechange}?semester_id=${semestechange}&scheme_id=${schemeId}`); 

        setCoursecomponenttypeData(response.data);
        course_code()

      } catch (error) {
        toast.error("something went wrong");
        console.error('Error fetching Course data:', error);
      }
    };

    if (semestechange !== false) {
      setCoursecomponenttypeData([]);
      fetchData();
    }



  }, [semestechange]);


  const handleDisciplineChange = (event) => {
    const selectedDisciplineId = event.target.value;

    const selectedDiscipline = discipline.find(d => d.id == selectedDisciplineId);

    if (selectedDiscipline) {
      setSchemeId(selectedDiscipline.scheme_id);

      sessionStorage.setItem("scheme_id", selectedDiscipline.scheme_id);
    }

    course_code(event);
  };

const handleAwardedDisciplineChange = (event) => {
    const selectedAwdDisciplineId = event.target.value;

    const selectedDiscipline = discipline.find(d => d.id == selectedAwdDisciplineId);    
  };

  const course_code = async () => {


    setErrors(prevErrors => ({
      ...prevErrors,
      ccoursecode: ""
    }));

    setIsEditable(false);


    const discipline_id = document.getElementById('discipline_id').value;
    const semesterid = document.getElementById('semester_id').value;
    const course_curriculum_structure_component_id = document.getElementById('coursecomponentstype').value;
//alert("course_curriculum_structure_component_id",course_curriculum_structure_component_id);


    if (course_curriculum_structure_component_id == 1 || course_curriculum_structure_component_id == 12) {
      setAecflag(true);
      setMinorflag(false);
      setugpspecialisationflag(false);

    }
    else if (course_curriculum_structure_component_id == 5 || course_curriculum_structure_component_id == 6 || course_curriculum_structure_component_id == 7) {

      http.get(`/Admin/getminor`, {
        params: {
          discipline: discipline_id
        }
      }).then(response => {

        setMinorData(response.data);
        setMinorflag(true);
        setAecflag(false);
        setugpspecialisationflag(false);
        setugpspecialisation([]);
      })
        .catch(error => {
          setMinorflag(false);
          setAecflag(false);
          setugpspecialisationflag(false);
        })

    }
    else if (course_curriculum_structure_component_id == 8 || course_curriculum_structure_component_id == 33 || course_curriculum_structure_component_id == 34 || course_curriculum_structure_component_id == 35) {

      http.get(`/Admin/getugpspecialisation`, {
        params: {
          discipline: discipline_id
        }
      }).then(response => {

        setugpspecialisation(response.data);
        setugpspecialisationflag(true);
        setMinorflag(false);
        setAecflag(false);
        setMinorData([]);

      })
        .catch(error => {
          setugpspecialisation([]);
          setugpspecialisationflag(false);
          setMinorflag(false);
          setAecflag(false);
        })

    }
    else {
      setugpspecialisationflag(false);
      setAecflag(false);
      setMinorflag(false);
    }


    if (discipline_id && semesterid && course_curriculum_structure_component_id) {
      try {
        const response = await http.get('/Admin/coursecodegeneration', {
          params: {
            semester_id: semesterid,
            discipline_id: discipline_id,
            course_curriculum_structure_component_id: course_curriculum_structure_component_id
          }
        });
        const courseCode = response.data.slice(0, -3);
        const courseCode3digit = response.data.slice(-3);

        setCoursecode(courseCode);
        setCoursecodedigit(courseCode3digit)
      } catch (error) {
        toast.error("somthing went wrong");
        console.error('Error fetching Course data:', error);
      }
    } else {
      setCoursecode(false);
      setCoursecodedigit(false);

    }
  };

  const toggleEdit = () => {
    setIsEditable(!isEditable);
  };

  const coursecodechange = (e) => {
    const value = e.target.value;
    const semesterid = parseInt(document.getElementById('semester_id').value, 10);
    let minRange, maxRange;

    switch (semesterid) {
      case 1:
      case 2:
        minRange = 100;
        maxRange = 199;
        break;
      case 3:
      case 4:
        minRange = 200;
        maxRange = 299;
        break;
      case 5:
      case 6:
        minRange = 300;
        maxRange = 399;
        break;
      case 7:
      case 8:
        minRange = 400;
        maxRange = 499;
        break;
      default:
        minRange = 100;
        maxRange = 199;
        break;
    }

    if (value && value >= minRange && value <= maxRange) {
      setErrors(prevErrors => ({
        ...prevErrors,
        ccoursecode: ""
      }));
    } else {
      setErrors(prevErrors => ({
        ...prevErrors,
        ccoursecode: `Enter a value between ${minRange} and ${maxRange}`
      }));
    }
  }
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };


  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12" >
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Add Course</h5>
                    </div>
                  </div>
                  <div id="main_section" className="card-body">
                    {message && (
                      <div className="alert alert-danger mar2" role="alert">
                        <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                      </div>
                    )}
                    {commonError && (
                      <div className="alert alert-danger mar2" role="alert">
                        <p style={{ textAlign: 'center', textJustify: 'auto' }}> {commonError}</p>
                      </div>
                    )}

                    <div className="card-body pdg">
                      <div className="table-responsive">



                        <div className="card-body custom-input">

                          <div className="row">
                            <div className="col">
                              <div className="mb-3 row">
                                <label className="col-sm-7">Course Title <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <input className="form-control input-air-primary" type="text" id="course_code" name="course_code" placeholder="Course Title" />
                                  {errors.cname && <p className="text-danger">{errors.cname}</p>}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-sm-7">Faculty Name <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" onChange={isdisiplin} required>
                                    <option value={0} >Select Faculty</option>

                                    {faculty.map(facultys => (

                                      <option value={facultys.id} selected={sessionStorage.getItem("faculty_id") == facultys.id ? 'selected' : null}>{facultys.faculty_name}</option>
                                    ))}

                                  </select>
                                  {errors.cfaculty && <p className="text-danger">{errors.cfaculty}</p>}
                                </div>

                              </div>
                              <div className="mb-3 row">

                                <label className="col-sm-7">Discipline <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="discipline_id" name="discipline_id" onChange={handleDisciplineChange} required>
                                    <option value={0}>Select Discipline</option>
                                    {discipline.map(disciplines => (
                                      disciplines.faculty_id == facultyname && (
                                        <option key={disciplines.id} value={disciplines.id} selected={sessionStorage.getItem("discipline_id") == disciplines.id}>{disciplines.discipline_name}</option>
                                      )
                                    ))}
                                  </select>
                                  {errors.cdiscipline && <p className="text-danger">{errors.cdiscipline}</p>}
                                </div>
                              </div>
                              
                              <div className="mb-3 row">

                                <label className="col-sm-7">Awarded Discipline <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="awarded_discipline_id" name="awarded_discipline_id" onChange={handleAwardedDisciplineChange} required>
                                    <option value={0}>Select Discipline</option>
                                    {discipline.map(disciplines => (
                                      disciplines.faculty_id == facultyname && (
                                        <option key={disciplines.id} value={disciplines.id} selected={sessionStorage.getItem("discipline_id") == disciplines.id}>{disciplines.discipline_name}</option>
                                      )
                                    ))}
                                  </select>
                                  {errors.awarded_discipline && <p className="text-danger">{errors.awarded_discipline}</p>}
                                </div>
                              </div>

                              <div className="mb-3 row">

                                <label className="col-sm-7">Semester <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="semester_id" name="semester_id" onChange={issemester} required>
                                    <option value={0}>Select Semester</option>
                                    {semester.map(semesters => (

                                      <option value={semesters.semester_no} selected={
                                        semestechange == semesters.id ? 'selected' : null}>{semesters.semester_name}</option>
                                    )
                                    )}
                                  </select>
                                  {errors.csemester && <p className="text-danger">{errors.csemester}</p>}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="col-sm-7">Select Course Component Type <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="coursecomponentstype" name="coursecomponentstype" onChange={course_code} required>
                                    <option value="">---Select---</option>


                                    {coursecomponentstypes.length > 0 && (
                                      coursecomponentstypes.map(coursecomponentstype => (
                                        <option key={coursecomponentstype.course_curriculum_structure_component_id} value={coursecomponentstype.course_curriculum_structure_component_id}>{coursecomponentstype.course_discipline_component}</option>
                                      ))
                                    )}

                                  </select>
                                  {errors.ccurriculum && <p className="text-danger">{errors.ccurriculum}</p>}
                                </div>
                              </div>

                              {aecflag && (

                                <div className="mb-3 row">
                                  <label className="col-sm-7">AEC Group  <span className="errorclr">*</span></label>
                                  <div className="col-sm-5">
                                    <select className="form-control form-select scrollable-bar-select" id="aec_group" name="aec_group" required>
                                      <option value="0">---Select---</option>
                                      <option value="1">Humanities</option>
                                      <option value="2">Science</option>
                                      <option value="3" >Commerce</option>
                                    </select>
                                    {errors.caecgroup && <p className="text-danger">{errors.caecgroup}</p>}
                                  </div>
                                </div>

                              )}

                              {minorflag && (

                                <div className="mb-3 row">
                                  <label className="col-sm-7">Minor Group  <span className="errorclr">*</span></label>
                                  <div className="col-sm-5">
                                    <select className="form-control form-select scrollable-bar-select" id="minor_group" name="minor_group" required>
                                      <option value="">---Select---</option>
                                      {minordata.map(minor => (
                                        <option key={minor.id} value={minor.id}>
                                          {minor.minors}
                                        </option>
                                      ))}
                                    </select>
                                    {errors.caecgroup && <p className="text-danger">{errors.caecgroup}</p>}
                                  </div>
                                </div>

                              )}

                              {ugpspecialisationflag && (

                                <div className="mb-3 row" id="spec_row">
                                  <label className="col-sm-7">Specialisation  <span className="errorclr">*</span></label>
                                  <div className="col-sm-5">
                                    <select className="form-control form-select scrollable-bar-select" id="ugpspecialisation_group" name="ugpspecialisation_group" required>
                                      <option value="">---Select---</option>
                                      <option value="56">Not Applicable</option>
                                      {ugpspecialisation.map(spec => (
                                        <option key={spec.ugp_specialisation_id} value={spec.ugp_specialisation_id}>
                                          {spec.ugp_specialisation_name}
                                        </option>
                                      ))}
                                    </select>
                                    {errors.specialisation && <p className="text-danger">{errors.specialisation}</p>}
                                  </div>
                                </div>

                              )}



                              <div className="mb-3 row">
                                <label className="col-sm-7">Course Code</label>
                                <div className="col-sm-5">
                                  <div className="input-container">
                                    <span class="non-editable" id="nonEditable">{coursecode ? coursecode : ""}</span>
                                    {isEditable ? (

                                      <input type="text" class="form-control editable" id="inlineFormCourseCode" defaultValue={coursecodedigit} onChange={coursecodechange} maxLength={3} required />

                                    ) : (
                                      <>

                                        <input type="text" class="form-control editable" id="inlineFormCourseCode" placeholder="Course Code" value={coursecodedigit ? coursecodedigit : ''} maxLength={3} readOnly onClick={toggleEdit} />

                                      </>
                                    )}

                                  </div>
                                  {errors.ccoursecode && <p className="text-danger">{errors.ccoursecode}</p>}
                                </div>

                              </div>

                              <div className="mb-3 row">
                                <label className="col-sm-7">Course Type<span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="courseidoftype" name="courseType"
                                    onChange={(e) => {
                                      if (e.target.value === 'T') {
                                        setPracticalExternalEnabled(false);
                                        setPracticalInternalEnabled(false);
                                        setTheoryExternalEnabled(true);
                                        setTheoryInternalEnabled(true);

                                      }
                                      else if (e.target.value === 'P') {
                                        setTheoryExternalEnabled(false);
                                        setTheoryInternalEnabled(false);
                                        setPracticalExternalEnabled(true);
                                        setPracticalInternalEnabled(true);

                                      }
                                      else if (e.target.value === 'B') {
                                        setTheoryExternalEnabled(true);
                                        setTheoryInternalEnabled(true);
                                        setPracticalExternalEnabled(true);
                                        setPracticalInternalEnabled(true);

                                      }
                                      setCourseType(e.target.value);
                                      setTotalCredit(0);
                                      setLectureCredit1("0");
                                      setPracticalCredit1("0");
                                    }}

                                  >

                                    <option value="0" >---Select---</option>
                                    <option value="T" >Theory(T)</option>
                                    <option value="P">Practical(P)</option>
                                    <option value="B">Both(B)</option>
                                  </select>
                                  {errors.ccoursetype && <p className="text-danger">{errors.ccoursetype}</p>}
                                </div>
                              </div>

                              {courseType === 'P' && (
                                <div className="mb-3 row" id="pract_row">

                                  <label className="col-sm-7">Practical Category<span className="errorclr">*</span></label>
                                  <div className="col-sm-5">
                                    <select
                                      className="form-control form-select"
                                      id="practicalType"
                                      name="practicalType"
                                      onChange={(e) => setPracticalCategoryType(e.target.value)}
                                    >
                                      <option value="">---Select---</option>
                                      <option value="P">Practical(P)</option>
                                      <option value="PJ">Project(PJ)</option>
                                      <option value="D">Dissertation(D)</option>
                                      <option value="I">Internship(I)</option>
                                      <option value="V">Viva(V)</option>

                                    </select>

                                    {errors.practicalType && <p className="text-danger">{errors.practicalType}</p>}
                                  </div>
                                </div>

                              )}

                              {courseType != false && (


                                <div className="row">
                                  <label className="col-sm-7">Credit</label>
                                  <div className="col-sm-5">
                                    <div className="row">
                                      {(courseType === 'T' || courseType === 'B') && (
                                        <div className="col-md-4 col-sm">
                                          <input type="text" className="form-control" id="lecture" name="lecture" placeholder="Theory" onChange={(e) => setLectureCredit1(e.target.value)} Value={lectureCredit1} />
                                        </div>
                                      )}
                                      {(courseType === 'P' || courseType === 'B') && (
                                        <div className="col-md-4 col-sm">
                                          <input type="text" className="form-control" id="tutorial" name="tutorial" placeholder="Practical" onChange={(e) => setPracticalCredit1(e.target.value)} Value={practicalCredit1} />
                                        </div>
                                      )}


                                      <div className="col-md-4 col-sm">
                                        <input type="text" className="form-control" id="total" name="total" placeholder="Total" Value={totalCredit} disabled />
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              )}
                              <h5 id="Mark_Details" className="pdg3">Mark Details</h5>
                              <div className="mb-3 row">
                                <div className="container box1">
                                  <div className="row g-4">
                                    {(courseType === 'T' || courseType === 'B') && (
                                      <>
                                        <div className="col-md-6">
                                          <div className="border rounded p-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                              <label className="form-label fw-bold mb-0">Theory Internal</label>
                                              <div className="form-check form-switch">
                                                {/* Avoid checkbox for avoinding disable */}
                                                {/* <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  onChange={(e) => setTheoryInternalEnabled(e.target.checked)}
                                                  checked={theoryInternalEnabled}

                                                /> */}
                                              </div>
                                            </div>
                                            <div className="row g-2">
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Min"
                                                  name="theoryMin"
                                                  disabled={!theoryInternalEnabled}
                                                  id='theoryMin'

                                                />
                                              </div>
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Max"
                                                  name="theoryMax"
                                                  disabled={!theoryInternalEnabled}
                                                  id='theoryMax'

                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-md-6">
                                          <div className="border rounded p-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                              <label className="form-label fw-bold mb-0">Theory External</label>
                                              <div className="form-check form-switch">
                                                {/* Avoid checkbox for avoinding disable */}
                                                {/* <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  onChange={(e) => setTheoryExternalEnabled(e.target.checked)}
                                                  checked={theoryExternalEnabled}

                                                /> */}
                                              </div>
                                            </div>
                                            <div className="row g-2">
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Min"
                                                  name="theoryExternalMin"
                                                  disabled={!theoryExternalEnabled}
                                                  id='theoryExternalMin'

                                                />
                                              </div>
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Max"
                                                  name="theoryExternalMax"
                                                  disabled={!theoryExternalEnabled}
                                                  id='theoryExternalMax'

                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}

                                    {(courseType === 'P' || courseType === 'B') && (
                                      <>
                                        <div className="col-md-6">
                                          <div className="border rounded p-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                              <label className="form-label fw-bold mb-0">Practical Internal</label>
                                              <div className="form-check form-switch">
                                                {/* Avoid checkbox for avoinding disable */}

                                                {/* <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  onChange={(e) => setPracticalInternalEnabled(e.target.checked)}
                                                  id="practicalInternalEnabled"
                                                  checked={practicalInternalEnabled}

                                                /> */}

                                              </div>
                                            </div>
                                            <div className="row g-2">
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Min"
                                                  name="practicalInternalMin"
                                                  disabled={!practicalInternalEnabled}
                                                  id='practicalInternalMin'

                                                />
                                              </div>
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Max"
                                                  name="practicalInternalMax"
                                                  disabled={!practicalInternalEnabled}
                                                  id='practicalInternalMax'

                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="col-md-6">
                                          <div className="border rounded p-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                              <label className="form-label fw-bold mb-0">Practical External</label>
                                              <div className="form-check form-switch">
                                                {/* Avoid checkbox for avoinding disable */}

                                                {/* <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  onChange={(e) => setPracticalExternalEnabled(e.target.checked)}
                                                  id="practicalExternalEnabled"
                                                  checked={practicalExternalEnabled}

                                                /> */}

                                              </div>
                                            </div>
                                            <div className="row g-2">
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Min"
                                                  name="practicalExternalMin"
                                                  disabled={!practicalExternalEnabled}

                                                  id='practicalExternalMin'
                                                />
                                              </div>
                                              <div className="col-6">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="Max"
                                                  name="practicalExternalMax"
                                                  disabled={!practicalExternalEnabled}

                                                  id='practicalExternalMax'
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>


                              <h5 id="" className="pdg3">Course components</h5>

                              <div className="mb-3 row">
                                <div className="container box1">
                                  <div className="mb-3 row">
                                    <label className="col-sm-7">Select Course component</label>
                                    <div className="col-sm-5">
                                      <Select
                                        maxMenuHeight={200}
                                        menuPlacement="auto"
                                        styles={customStyles}
                                        className="form-control"
                                        id="coursecomponent"
                                        name="coursecomponent"
                                        isMulti
                                        options={coursecomponent.map(coursecomponents => ({
                                          value: coursecomponents.id,
                                          label: coursecomponents.course_component
                                        }))}
                                        onChange={handleCourseComponentChange}
                                        required
                                      />

                                      {errors.courseComponent && (
                                        <p className="text-danger mt-2">
                                          {errors.courseComponent}
                                        </p>
                                      )}

                                    </div>
                                  </div>
                                  {/* {selectedCourseComponents.length > 0 && (
  <div className="mb-3 row">
    <label className="col-sm-7">Credits & Hours</label>

    <div className="col-sm-5">
      <div className="row">
        <div className="col-6">
          <input
            type="number"
            className="form-control"
            name="total_credit"
            placeholder="Total Credit"
          />
        </div>

        <div className="col-6">
          <input
            type="number"
            className="form-control"
            name="total_hours"
            placeholder="Total Hours"
          />
        </div>
      </div>
    </div>
  </div>
)} */}


                                  {/* Credit and Hours Section */}
                                  {selectedCourseComponents.length > 0 && (
                                    <div className="credit-hours-section">
                                      <div className="mb-4">
                                        <div className="credit-hours-wrapper">
                                          <h6 className="section-title">Credits & Hours</h6>

                                          <div className="row">
                                            {Object.entries(componentWiseData).map(([id, data]) => (
                                              <div className="col-md-6 mb-3" key={id}>
                                                <div className="component-card">
                                                  <div className="component-title">
                                                    {data.componentName}
                                                  </div>

                                                  <div className="row g-2">
                                                    <div className="col-6">
                                                      <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Total Credit"
                                                        value={data.total_credit}
                                                        onChange={(e) =>
                                                          setComponentWiseData(prev => ({
                                                            ...prev,
                                                            [id]: {
                                                              ...prev[id],
                                                              total_credit: e.target.value
                                                            }
                                                          }))
                                                        }
                                                      />
                                                      {errors.componentErrors?.[id]?.total_credit && (
                                                        <p className="text-danger mt-2">
                                                          {errors.componentErrors[id].total_credit}
                                                        </p>
                                                      )}


                                                    </div>

                                                    <div className="col-6">
                                                      <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Total Hours"
                                                        value={data.total_hours}
                                                        onChange={(e) =>
                                                          setComponentWiseData(prev => ({
                                                            ...prev,
                                                            [id]: {
                                                              ...prev[id],
                                                              total_hours: e.target.value
                                                            }
                                                          }))
                                                        }
                                                      />
                                                      {errors.componentErrors?.[id]?.total_hours && (
                                                        <p className="text-danger mt-2">
                                                          {errors.componentErrors[id].total_hours}
                                                        </p>
                                                      )}


                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {/* Credit and Hours Section end */}
                                </div>
                              </div>



                              <div className="mb-3 row">
                                <label className="col-sm-7">Level of Course <span className="errorclr">*</span></label>
                                <div className="col-sm-5">
                                  <select className="form-control " id="courselevel_id" name="courselevel_id" required readOnly>

                                    {courselevel.map(courselevels => (
                                      courselevels.id == courselevel1 && (
                                        <option value={courselevels.id} selected>{courselevels.course_level}</option>
                                      )
                                    ))}

                                  </select>
                                  {errors.clevel && <p className="text-danger">{errors.clevel}</p>}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-sm-7">No. of Course Outcomes</label>
                                <div className="col-sm-5">
                                  <select className="form-control form-select scrollable-bar-select" id="courseoutcome" name="courseoutcome" onChange={handleCourseOutcomeChange} required>
                                    {/* {[...Array(Math.max(0, 9 - totalCredit)).keys()].map((value) => (
                                      <option key={value} value={value + totalCredit}>{value + totalCredit}</option>
                                    ))} */}
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                    <option value={6}>6</option>
                                    <option value={7}>7</option>
                                    <option value={8}>8</option>
                                    <option value={9}>9</option>
                                    <option value={10}>10</option>
                                    <option value={11}>11</option>
                                  </select>
                                </div>
                              </div>
                              <h5 className="pdg3">CO Statements</h5>
                              <div className="mb-3 row">
                                <div className="container box1">
                                  <div className="row">
                                    <div className="col-md-1 col-sm">
                                    </div>
                                    <div className="col-md-3 col-sm">
                                      <label>State the Course Outcomes</label>
                                    </div>
                                    <div className="col-md-4 col-sm">
                                      <label>Select the Corresponding Learning Domain</label>
                                    </div>
                                    <div className="col-md-4 col-sm">
                                      <label>Enter the Corresponding PO</label>
                                    </div>
                                  </div>
                                  {sectionsData.map((section, index) => (
                                    <div key={index} className="row pdg3">
                                      <div className="col-md-1 col-sm">
                                        <label>{`CO:${index + 1}`}</label>
                                      </div>
                                      <div className="col-md-3 col-sm">
                                        <input type="text" className="form-control" id={`outcome${index}`} name={`outcome${index}`} placeholder="" required />
                                      </div>
                                      <div className="col-md-4 col-sm">
                                        {/* //04-03-2024-multiselect */}
                                        <Select
                                          maxMenuHeight={200}
                                          menuPlacement="auto"
                                          styles={customStyles}
                                          className="form-control ht"
                                          id={`domains${index}`}
                                          name={`domains${index}`}
                                          multiple
                                          aria-label="multiple select example"
                                          required
                                          isMulti
                                          value={selectedDomainOptions[index]}
                                          onChange={(selectedOptions) => handleDomainChange(selectedOptions, index)}
                                          options={learningoptions}
                                        />
                                      </div>

                                      <div className="col-md-4 col-sm">
                                        {/* //04-03-2024-multiselect */}
                                        <Select
                                          maxMenuHeight={200}
                                          menuPlacement="auto"
                                          styles={customStyles}
                                          className="form-control ht"
                                          id={`outcomeDomains${index}`}
                                          name={`outcomeDomains${index}`}
                                          multiple
                                          aria-label="multiple select example"
                                          required
                                          isMulti
                                          value={selectedOutcomeOptions[index]}
                                          onChange={(selectedOptions) => handleOutcomeChange(selectedOptions, index)}
                                          options={outcomeoptions}
                                        />

                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="col-sm-7">Remarks</label>
                                <div className="col-sm-5">
                                  <textarea className="form-control input-air-primary" id="remarks" name="remarks" placeholder="Remarks" onChange={(e) => setRemarks(e.target.value)} />
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 txt-aln">
                          <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                          <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
